import askGamblers from 'assets/images/askGamblers.svg';
import casinoOnlineLogo from 'assets/images/casinoOnlineApproved.svg';
import casinosAnalyzer from 'assets/images/casinosAnalyzer.png';
import playResponsibly from 'assets/images/playResponsibly.svg';

// `name` → `license-<name>` class on the image, so a page can resize one badge
export const LICENSE_BADGES = [
  {
    name: 'play-responsibly',
    alt: 'play responsibly',
    src: playResponsibly,
    width: 150,
    href: 'https://luckyelfcasino.com/responsible-gaming',
  },
  {
    name: 'casinos-analyzer',
    alt: 'casinosAnalyzer',
    src: casinosAnalyzer,
    width: 107,
    href: 'https://casinosanalyzer.com/free-spins-no-deposit',
    allowedDomainsOnly: true,
  },
  {
    name: 'casino-on-line',
    alt: 'casino-on-line',
    src: casinoOnlineLogo,
    width: 188,
    href: 'https://www.casino-on-line.com/review/lucky-elf-casino/',
  },
  {
    name: 'ask-gamblers',
    alt: 'ask gamblers',
    src: askGamblers,
    width: 133,
    href: 'https://www.askgamblers.com/online-casinos/reviews/lucky-elf-casino',
  },
];
